/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Insurance/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Insurance({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/PaymentPlans/Content/Content/PaymentPlan/Content/Content/Summary/Insurances/Insurance"
  
}) {
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let insuranceValueData = fromData.useDataFormat({ viewPath,
context: 'insurance',
format: fromHelpers.getInsuranceName,
})
let dtColorsBlack = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.black'
        })
let insuranceEstimatedReimbursementAmountValueData = fromData.useDataFormat({ viewPath,
context: 'insurance',
path: 'estimated_reimbursement_amount',
format: fromFormat.numberMoney,
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<div
  data-testid="Insurance.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-2s0C3T': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--ml-2-2s0C3T': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--mr-3-2s0C3T': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 flexGrow={1}
 flexShrink={1}
 flexBasis={0}
 data="insurance"
 format="helpers.js getInsuranceName"
 text={insuranceValueData}
 color={dtColorsBlack}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="insurance.estimated_reimbursement_amount"
 format="/Data/format.js numberMoney"
 text={insuranceEstimatedReimbursementAmountValueData}
 weight="medium"
 color={dtColorsBlack}
 marginLeft={dtSpaceS}
/>
</div>
{children}
</React.Fragment>)
}